import { Component } from 'react';

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalImage: '',
    };
  }

  renderTableSection = (title, icon, fields) => (
    <div className="mb-5">
      <h5 className="text-maroon mb-3">{icon} {title}</h5>
      <div className="table-responsive">
        <table className="table table-bordered table-sm profile-table">
          <tbody>
            {fields.map(([label, value], index) => (
              <tr key={index}>
                <th style={{ width: "35%" }}>{label}</th>
                <td>{value && value !== 'N/A' ? value : <span className="text-muted">Not Provided</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  openModal = (imageUrl) => {
    this.setState({ showModal: true, modalImage: imageUrl });
  };

  closeModal = () => {
    this.setState({ showModal: false, modalImage: '' });
  };

  render() {
    const { userData } = this.props;
    const { showModal, modalImage } = this.state;

    if (!userData) return <p>Loading profile...</p>;

    return (
      <div className="container mt-4">
        <div className="card shadow p-4 mb-5 bg-white rounded">
          <h2 className="text-center text-maroon mb-3">Profile Details</h2>
          <div className="divider mx-auto mb-4"></div>

          {/* Profile Photos */}
          <div className="mb-5">
            <h5 className="text-maroon mb-3">📷 Profile Photos</h5>
            <div className="row justify-content-start text-center g-4">
              {[1, 2].map((num) => (
                <div className="col-6 col-md-3" key={num}>
                  {userData[`Image_${num}`] === "YES" ? (
                    <img
                      src={`https://varenyamatrimonial.com/profile_images/${userData.User_Id}_${num}.webp`}
                      alt={`Profile ${num}`}
                      className="img-fluid rounded shadow-sm profile-photo"
                      onClick={() =>
                        this.openModal(`https://varenyamatrimonial.com/profile_images/${userData.User_Id}_${num}.webp`)
                      }
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center align-items-center text-muted border rounded shadow-sm profile-img-border"
                      style={{ width: '100%', maxWidth: '150px', height: '200px', fontSize: '0.85rem', fontWeight: 'bold' }}>
                      Image {num}<br />Not Uploaded
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Fullscreen Modal */}
            {showModal && (
              <div className="image-modal" onClick={this.closeModal}>
                <span className="close-btn" onClick={this.closeModal}>&times;</span>
                <img src={modalImage} alt="Full View" className="modal-content-img" />
              </div>
            )}
          </div>

          {/* Profile Data Sections */}
          {this.renderTableSection("Personal Details", "🧍", [
            ["User ID", userData.User_Id],
            ["Name", userData.Name],
            ["Date of Birth", userData.DOB],
            ["Gender", userData.Gender],
            ["Height", `${userData.Height} cm`],
            ["Weight", `${userData.Weight} kg`],
            ["Body Type", userData.Body_Type],
            ["Complexion", userData.Complexion],
            ["Blood Group", userData.Blood_Group],
            ["Mother Tongue", userData.Mother_Tongue],
            ["Eating Habits", userData.Eating_Habits],
            ["Smoking Habit", userData.Smoking_Habit],
            ["Drinking Habits", userData.Drinking_Habits],
            ["Profile Created By", userData.Profile_Created_by],
          ])}

          {this.renderTableSection("Horoscope Details", "🔯", [
            ["Time of Birth", userData.TOB],
            ["Place of Birth", userData.Place_Of_Birth],
            ["Gotra", userData.Gotra],
            ["Nakshatra", userData.Nakshatra],
            ["Rashi", userData.Rashi],
            ["Pada", userData.Pada],
          ])}

          {this.renderTableSection("Community & Religion", "🕉️", [
            ["Sub Caste", userData.Sub_Caste],
            ["Sub Sector", userData.Sub_Sector],
            ["Marital Status", userData.Marital_Status],
          ])}

          {this.renderTableSection("Education & Occupation", "🎓", [
            ["Education", userData.Education],
            ["Education Details", userData.Education_Details],
            ["Occupation", userData.Occupation],
            ["Occupation Details", userData.Occupation_Details],
            ["Annual Income", userData.Annual_Income],
          ])}

          {this.renderTableSection("Family Details", "👨‍👩‍👧‍👦", [
            ["Father", `${userData.Father_Name} (${userData.Father_Alive_Status})`],
            ["Father's Occupation", userData.Father_Occupation],
            ["Mother", `${userData.Mother_Name} (${userData.Mother_Alive_Status})`],
            ["Mother's Occupation", userData.Mother_Occupation],
            ["Family Values", userData.Family_Values],
            ["Family Status", userData.Family_Status],
            ["Family Type", userData.Family_Type],
            ["Ancestral Origin", userData.Ancestral_Origin],
          ])}

          {this.renderTableSection("Siblings", "👫", [
            ["Younger Brother", `${userData.No_Younger_Brother} (${userData.No_Younger_Brother_Married})`],
            ["Elder Brother", `${userData.No_Elder_Brother} (${userData.No_Elder_Brother_Married})`],
            ["Younger Sister", `${userData.No_Younger_Sister} (${userData.No_Younger_Sister_Married})`],
            ["Elder Sister", `${userData.No_Elder_Sister} (${userData.No_Elder_Sister_Married})`],
          ])}

          {this.renderTableSection("Contact & Address", "📞", [
            ["Mobile", userData.Mobile],
            ["Alternate Phone", userData.Alternative_Phone],
            ["Address", userData.Address],
            ["Pincode", userData.Pincode],
          ])}
        </div>
      </div>
    );
  }
}
